class UserService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getUsers(params) {
    return this.apiService.get('/api/v1/users', params);
  }

  getById(id) {
    return this.apiService.get(`/api/v1/users/${id}`);
  }

  getUsersPage(params) {
    return this.apiService.get('/api/v1/users/page', params);
  }

  support(params) {
    return this.apiService.post('/api/v1/users/support', params);
  }

  createUser(params) {
    return this.apiService.post('/api/v1/users', params);
  }

  deleteUsers(userIds) {
    return this.apiService.delete(`/api/v1/users?${userIds.map(id => `ids[]=${id}`).join('&')}`);
  }

  update(data) {
    return this.apiService.put(`/api/v1/users/${data.id}`, data);
  }

  resetUserPassword(id, params) {
    return this.apiService.put(`/api/v1/users/${id}/password`, params);
  }
}

export default UserService;
